const EXPRESS_EMPTY_STATE_ID = "express-shipping-empty-state";

function getExpressToggle() {
  return Array.from(document.querySelectorAll("input[data-express-shipping-toggle]")).filter(
    (el) => el instanceof HTMLInputElement
  );
}

function getStockToggle() {
  return Array.from(document.querySelectorAll("input[data-stock-toggle]")).filter(
    (el) => el instanceof HTMLInputElement
  );
}

function isExpressEnabledInURL() {
  const url = new URL(window.location.href);
  return url.searchParams.get("express_shipping") === "1";
}

function isStockEnabledInURL() {
  const url = new URL(window.location.href);
  return url.searchParams.get("in_stock") === "1";
}

function syncToggleFromURL() {
  const toggles = getExpressToggle();
  const enabled = isExpressEnabledInURL();
  for (const toggle of toggles) toggle.checked = enabled;
}

function syncStockFromURL() {
  const toggles = getStockToggle();
  const enabled = isStockEnabledInURL();
  for (const toggle of toggles) toggle.checked = enabled;
}

function updateURLFromToggle(paramName, isEnabled) {
  const url = new URL(window.location.href);
  url.searchParams.delete("page");
  if (isEnabled) url.searchParams.set(paramName, "1");
  else url.searchParams.delete(paramName);

  // Keep URL stable (theme uses sorted params for caching).
  url.searchParams.sort();
  history.pushState({ urlParameters: url.searchParams.toString() }, "", url.toString());
}

function getProductGridItems() {
  return Array.from(document.querySelectorAll(".product-grid__item"));
}

function setItemVisible(item, isVisible) {
  item.style.display = isVisible ? "" : "none";
}

function getOrCreateEmptyState() {
  const existing = document.getElementById(EXPRESS_EMPTY_STATE_ID);
  if (existing) return existing;

  const template = document.querySelector("template[data-express-empty-template]");
  if (!(template instanceof HTMLTemplateElement)) return null;

  const fragment = template.content.cloneNode(true);
  const container = document.createElement("div");
  container.appendChild(fragment);

  const emptyState = container.firstElementChild;
  if (!(emptyState instanceof HTMLElement)) return null;

  emptyState.id = EXPRESS_EMPTY_STATE_ID;
  return emptyState;
}

function mountEmptyState(emptyState) {
  const grid = document.querySelector(".product-grid");
  if (!(grid instanceof HTMLElement)) return;

  // Prefer inserting right before the grid list.
  const parent = grid.parentElement;
  if (!(parent instanceof HTMLElement)) return;

  if (!emptyState.isConnected) parent.insertBefore(emptyState, grid);
}

function unmountEmptyState() {
  const existing = document.getElementById(EXPRESS_EMPTY_STATE_ID);
  existing?.remove();
}

function applyExpressShippingFilter() {
  syncToggleFromURL();
  syncStockFromURL();

  const expressToggles = getExpressToggle();
  const stockToggles = getStockToggle();
  if (expressToggles.length === 0 && stockToggles.length === 0) return;

  const shouldFilterExpress = expressToggles.some((toggle) => toggle.checked);
  const shouldFilterStock = stockToggles.some((toggle) => toggle.checked);
  const items = getProductGridItems();

  let visibleCount = 0;
  for (const item of items) {
    if (!(item instanceof HTMLElement)) continue;

    const hasExpress = item.dataset.expressShipping === "1";
    const isInStock = item.dataset.inStock === "1";
    const isVisible =
      (!shouldFilterExpress || hasExpress) &&
      (!shouldFilterStock || isInStock);
    setItemVisible(item, isVisible);
    if (isVisible) visibleCount += 1;
  }

  if ((shouldFilterExpress || shouldFilterStock) && items.length > 0 && visibleCount === 0) {
    const emptyState = getOrCreateEmptyState();
    if (emptyState) mountEmptyState(emptyState);
  } else {
    unmountEmptyState();
  }
}

function createScheduler(fn) {
  let rafId = null;
  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      fn();
    });
  };
}

if (!window.__expressShippingFilterInitialized) {
  window.__expressShippingFilterInitialized = true;

  const scheduleApply = createScheduler(applyExpressShippingFilter);

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.hasAttribute("data-express-shipping-toggle")) {
      updateURLFromToggle("express_shipping", target.checked);
      for (const toggle of getExpressToggle()) toggle.checked = target.checked;
      scheduleApply();
    }
    if (target instanceof HTMLInputElement && target.hasAttribute("data-stock-toggle")) {
      updateURLFromToggle("in_stock", target.checked);
      for (const toggle of getStockToggle()) toggle.checked = target.checked;
      scheduleApply();
    }
  });

  window.addEventListener("popstate", scheduleApply);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") continue;
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        scheduleApply();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Run once on load (works even if the module executes after DOMContentLoaded).
  scheduleApply();
}
